// IntersectionObserver Polyfill
if (!window.IntersectionObserver) {
  window.IntersectionObserver = function (callback, options = {}) {
    this.observe = function (target) {
      // Simple polyfill that checks visibility on scroll
      const checkIntersection = () => {
        const rect = target.getBoundingClientRect();
        const rootRect = (options.root || document.documentElement).getBoundingClientRect();
        const isIntersecting = !(
          rect.bottom < rootRect.top ||
          rect.top > rootRect.bottom ||
          rect.right < rootRect.left ||
          rect.left > rootRect.right
        );
        callback([{
          target: target,
          isIntersecting: isIntersecting,
          intersectionRect: isIntersecting ? rect : null,
          intersectionRatio: isIntersecting ? 1 : 0
        }]);
      };
      window.addEventListener('scroll', checkIntersection);
      window.addEventListener('resize', checkIntersection);
      // Initial check
      checkIntersection();
    };
    this.unobserve = function (target) {
      // Cleanup
      window.removeEventListener('scroll', this.checkIntersection);
      window.removeEventListener('resize', this.checkIntersection);
    };
    this.disconnect = function () {
      // Cleanup
      window.removeEventListener('scroll', this.checkIntersection);
      window.removeEventListener('resize', this.checkIntersection);
    };
  };
}

// ResizeObserver Polyfill
if (!window.ResizeObserver) {
  window.ResizeObserver = function (callback) {
    this.observe = function (target) {
      // Simple polyfill that checks size on window resize
      const resizeHandler = () => {
        callback([{
          target: target,
          contentRect: target.getBoundingClientRect()
        }]);
      };
      window.addEventListener('resize', resizeHandler);
      // Initial call
      resizeHandler();
    };
    this.unobserve = function (target) {
      // Cleanup
      window.removeEventListener('resize', this.resizeHandler);
    };
    this.disconnect = function () {
      // Cleanup
      window.removeEventListener('resize', this.resizeHandler);
    };
  };
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

var trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  var navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  var currentFocusedElement = null;
  var mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  var openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  var summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    // Get references to elements
    this.input = this.querySelector('input');
    this.minusButton = this.querySelector('button[name="minus"]');
    this.plusButton = this.querySelector('button[name="plus"]');
    this.changeEvent = new Event('change', { bubbles: true });

    if (!this.input || !this.minusButton || !this.plusButton) {
      console.error('QuantityInput: Missing required elements (input, minus button, or plus button).');
      return;
    }
    // ★★★ デバッグログ追加: インスタンス生成確認 ★★★
    const inputId = this.input?.id || 'unknown';
    console.log(`QuantityInput.constructor: Initializing instance for input#${inputId}`);
    // ★★★ デバッグログ追加ここまで ★★★

    // Re-add event listeners directly in constructor
    this.addListeners();

    // Initial state check remains important
    // Use setTimeout to ensure potential 'max' attribute from Liquid is set
    setTimeout(() => {
        this.updateButtonStates();
    }, 0);
  }

  addListeners() {
    // Remove existing listeners first to avoid duplicates if called again
    this.minusButton?.removeEventListener('click', this.onButtonClick);
    this.plusButton?.removeEventListener('click', this.onButtonClick);
    this.input?.removeEventListener('change', this.onInputChange);

    // Bind 'this' context correctly
    this.onButtonClick = this.onButtonClick.bind(this);
    this.onInputChange = this.onInputChange.bind(this);

    // Add new listeners
    this.minusButton?.addEventListener('click', this.onButtonClick);
    this.plusButton?.addEventListener('click', this.onButtonClick);
    this.input?.addEventListener('change', this.onInputChange);
    console.log(`QuantityInput.addListeners: Added listeners for input#${this.input?.id || 'unknown'}`);
  }

  // Renamed back from handleButtonClick
  onButtonClick(event) {
    // ★★★ デバッグログ追加: ボタンクリックイベント発生確認 ★★★
    const inputId = this.input?.id || 'unknown';
    console.log(`QuantityInput.onButtonClick: Click detected on button "${event.target.name}" for input#${inputId}`);
    // ★★★ デバッグログ追加ここまで ★★★
    event.preventDefault(); // Keep preventDefault here
    const previousValue = this.input.value;
    const max = this.input.max ? parseInt(this.input.max, 10) : null;
    const min = this.input.min ? parseInt(this.input.min, 10) : 1;

    if (event.target.name === 'plus') { // Use event.target.name
      if (max === null || parseInt(this.input.value, 10) < max) {
        this.input.stepUp();
      }
    } else if (event.target.name === 'minus') { // Use event.target.name
       if (parseInt(this.input.value, 10) > min) {
         this.input.stepDown();
       }
    }

    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
      this.updateButtonStates();
    }
  }

  // Renamed back from handleInputChange
  onInputChange() {
    // ★★★ デバッグログ追加: 手動入力変更イベント発生確認 ★★★
    const inputId = this.input?.id || 'unknown';
    console.log(`QuantityInput.onInputChange: Change detected for input#${inputId}, new raw value: "${this.input.value}"`);
    // ★★★ デバッグログ追加ここまで ★★★
    const value = parseInt(this.input.value, 10);
    const min = this.input.min ? parseInt(this.input.min, 10) : 1;
    const max = this.input.max ? parseInt(this.input.max, 10) : null;

    // Validate against min
    if (value < min) {
      this.input.value = min;
    }

    // Validate against max
    if (max !== null && value > max) {
      this.input.value = max;
    }

    // Handle non-numeric input or empty string (reset to min)
    if (isNaN(value) || this.input.value === '') {
      this.input.value = min;
    }

    this.updateButtonStates(); // Update buttons after validation
  }

  updateButtonStates() {
    const value = parseInt(this.input.value, 10);
    const min = this.input.min ? parseInt(this.input.min, 10) : 1;
    const max = this.input.max ? parseInt(this.input.max, 10) : null; // Ensure max is parsed as integer or null

    // ★★★ デバッグログ追加: updateButtonStates内の値確認 ★★★
    console.log(`QuantityInput.updateButtonStates: value=${value}, min=${min}, max=${max}`);
    // ★★★ デバッグログ追加ここまで ★★★

    // Disable minus button if value is at min
    const shouldDisableMinus = value <= min;
    this.minusButton.disabled = shouldDisableMinus;
    console.log(`QuantityInput.updateButtonStates: Minus button disabled? ${shouldDisableMinus} (value <= min: ${value} <= ${min})`); // Log minus button state

    // Disable plus button if value is at max (and max is defined)
    const shouldDisablePlus = max !== null && value >= max;
    this.plusButton.disabled = shouldDisablePlus;
    console.log(`QuantityInput.updateButtonStates: Plus button disabled? ${shouldDisablePlus} (max !== null && value >= max: ${max !== null} && ${value} >= ${max})`); // Log plus button state

    // Ensure buttons are enabled if within valid range (This part might be redundant but kept for safety)
    if (value > min) {
      this.minusButton.disabled = false;
    }
    if (max === null || value < max) {
      this.plusButton.disabled = false;
    }
  }
}

customElements.define('quantity-input', QuantityInput);

// --- MutationObserver to update max attribute AND re-attach listeners if element is replaced ---
document.addEventListener('DOMContentLoaded', () => {
  // Remove the delegated listeners added previously
  // document.body.removeEventListener('click', ...); // Need reference to the exact function, complex to remove here
  // document.body.removeEventListener('change', ...); // Need reference to the exact function, complex to remove here
  console.log("Removed previous delegated listeners (attempted).");


  // --- MutationObserver Setup ---
  const productForms = document.querySelectorAll('form[id^="product-form-"]');

  productForms.forEach(form => {
    const productScope = form.closest('.product'); // Define scope for finding the component
    if (!productScope) return;

    // Function to find and setup observer for the quantity input within the scope
    const setupQuantityObserver = (scope) => {
      const quantityInputComponent = scope.querySelector('quantity-input');
      if (!quantityInputComponent) {
        console.warn('MutationObserver: quantity-input not found in scope:', scope);
        return;
      }

      const observer = new MutationObserver((mutationsList) => {
        let needsReinit = false;
        let needsStateUpdate = false;
        let targetComponent = quantityInputComponent; // Assume current component unless replaced

        for (const mutation of mutationsList) {
          // Check if the quantity-input element itself was added
          if (mutation.type === 'childList') {
             mutation.addedNodes.forEach(node => {
               if (node.matches && node.matches('quantity-input')) {
                 console.log('MutationObserver: quantity-input element added, potentially replaced.');
                 targetComponent = node; // Target the newly added component
                 needsReinit = true;
               } else if (node.querySelector && node.querySelector('quantity-input')) {
                 // Check if added node contains the quantity-input
                 console.log('MutationObserver: Parent containing quantity-input added.');
                 targetComponent = node.querySelector('quantity-input');
                 needsReinit = true;
               }
             });
          }
          // Check if the max attribute changed on the input *within* the observed component
          if (mutation.type === 'attributes' && mutation.target === targetComponent.input && mutation.attributeName === 'max') {
             console.log('MutationObserver: max attribute changed.');
             needsStateUpdate = true;
          }
        }

        // If reinitialization is needed (element likely replaced)
        if (needsReinit && targetComponent && targetComponent.addListeners) {
           console.log('MutationObserver: Re-initializing listeners and updating states for potentially replaced component.');
           setTimeout(() => { // Use setTimeout to ensure component is fully ready
              targetComponent.addListeners(); // Re-attach listeners
              targetComponent.updateButtonStates(); // Update states based on new attributes
              if (targetComponent.onInputChange) { // Re-validate value
                  targetComponent.onInputChange();
              }
           }, 0);
        }
        // If only state update is needed (max attribute changed on existing element)
        else if (needsStateUpdate && targetComponent && targetComponent.updateButtonStates) {
           console.log('MutationObserver: Updating button states due to max attribute change.');
           setTimeout(() => { // Use setTimeout for consistency
              targetComponent.updateButtonStates();
              if (targetComponent.onInputChange) { // Re-validate value
                  targetComponent.onInputChange();
              }
           }, 0);
        }
      });

      // Observe the input for max attribute changes
      if (quantityInputComponent.input) {
        observer.observe(quantityInputComponent.input, { attributes: true, attributeFilter: ['max'] });
        console.log('MutationObserver: Observing attributes on', quantityInputComponent.input);
      }

      // Observe the container that likely gets updated on variant change for childList changes
      const formId = form.id; // Get the id first
      let productInfoContainer = null;
      // Check if formId is a string and starts with the expected prefix before splitting
      if (typeof formId === 'string' && formId.startsWith('product-form-')) {
          const productId = formId.split('-').pop();
          productInfoContainer = scope.querySelector('#ProductInfo-' + productId);
      } else {
          // Log a warning if the form ID is not as expected
          console.warn('QuantityInput Observer: Form element found without a valid string ID starting with "product-form-". Form:', form);
      }

      if (productInfoContainer) {
        // Observe the specific container if found
        observer.observe(productInfoContainer, { childList: true, subtree: true });
        console.log('MutationObserver: Observing subtree on', productInfoContainer);
      } else {
        // Fallback: Observe the broader product scope if the specific container isn't found or form ID was invalid
        observer.observe(scope, { childList: true, subtree: true });
        console.warn('QuantityInput Observer: Could not find specific product info container or form ID was invalid, observing product scope.', scope);
      }
    };

    // Initial setup
    setupQuantityObserver(productScope);

    // Re-setup observer if the whole product scope might be replaced (less common but possible)
    // const parentObserver = new MutationObserver((mutationsList) => {
    //    mutationsList.forEach(mutation => {
    //        if (Array.from(mutation.addedNodes).some(node => node === productScope)) {
    //            console.log("Product scope added, re-setting up quantity observer.");
    //            setupQuantityObserver(productScope);
    //        }
    //    });
    // });
    // if (productScope.parentNode) {
    //    parentObserver.observe(productScope.parentNode, { childList: true });
    // }

  });


  // --- Original Debug Listener for Variant Change (can be removed later) ---
  // This code block had syntax errors and is commented out now
  /*
      for (const mutation of mutationsList) {
        // Check if the quantity input itself or its attributes changed,
        // or if nodes were added/removed in a way that might affect the input (e.g., variant change replaced it)
        if (mutation.type === 'attributes' && mutation.target.matches('input[name="quantity"]') && mutation.attributeName === 'max' ||
            mutation.type === 'childList' && (mutation.addedNodes.length > 0 || mutation.removedNodes.length > 0)) {
          // Re-run the button state update when max attribute changes or structure changes
          // Use setTimeout to ensure the DOM update (like setting max) is complete
          setTimeout(() => {
            if (quantityInputComponent.updateButtonStates) { // Check if method exists
              console.log('QuantityInput: Updating button states due to mutation or max change.');
              quantityInputComponent.updateButtonStates();
            }
          }, 0);
          break; // No need to check other mutations if we found a relevant one
        }
      }
  */

});

function debounce(fn, wait) {
  var t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    var openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    var summaryElement = event.currentTarget;
    var detailsElement = summaryElement.parentNode;
    var isOpen = detailsElement.hasAttribute('open');
    var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    var detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    var animationStart;

    var handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      var elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    var popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    var button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      var modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    var poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      var content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      var deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();

    // Safely create ResizeObserver
    try {
      const resizeObserver = new ResizeObserver(entries => this.initPages());
      resizeObserver.observe(this.slider);
    } catch (error) {
      console.warn('ResizeObserver not supported, falling back to window resize event');
      window.addEventListener('resize', () => this.initPages());
    }

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    var previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', {
        detail: {
          currentPage: this.currentPage,
          currentElement: this.sliderItemsToShow[this.currentPage - 1]
        }
      }));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    var lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    var step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    var isFirstSlide = this.currentPage === 1;
    var isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    var focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    var focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    var slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      var button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    var slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    // Use event delegation on the host element
    this.addEventListener('change', this.handleVariantChange.bind(this));
    // ★★★ デバッグログ追加: コンストラクタ実行とリスナー設定対象の確認 ★★★
    console.log('VariantSelects.constructor: Initialized with event delegation listener on host element.');
    // ★★★ デバッグログ追加ここまで ★★★
  }

  handleVariantChange(event) {
    // Check if the event target is one of the variant inputs/selects inside this component
    if (!event.target.matches('select, input[type="radio"]')) {
      // console.log('VariantSelects.handleVariantChange: Event target is not a select or radio, ignoring.');
      return; // Ignore changes from other elements
    }

    // ★★★ デバッグログ追加: handleVariantChangeが呼び出されたか確認 ★★★
    console.log('VariantSelects.handleVariantChange: Method called by event on:', event.target);
    // ★★★ デバッグログ追加ここまで ★★★

    // Call the original logic
    this.onVariantChange();
  }

  onVariantChange() {
    // ★★★ デバッグログ追加: onVariantChangeが呼び出されたか確認 ★★★
    console.log('VariantSelects.onVariantChange: Core logic executing.');
    // ★★★ デバッグログ追加ここまで ★★★
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    var mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    var modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    var newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    var shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    var productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      var input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    var pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    var section = this.closest('section');
    if (!section) return;

    var productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        var id = `price-${this.dataset.section}`;
        var html = new DOMParser().parseFromString(responseText, 'text/html')
        var destination = document.getElementById(id);
        var source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        var price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        // --- ★★★ ここから修正 ★★★ ---
        // Update quantity input max attribute based on the new variant's inventory
        const quantityInputSource = html.querySelector(`#Quantity-${this.dataset.section}`); // Get input element from fetched HTML
        const quantityInputDestination = document.getElementById(`Quantity-${this.dataset.section}`); // Get the actual input element on the page

        // ★★★ デバッグログ追加: 取得元と設定先の要素、max属性の確認 ★★★
        console.log('VariantSelects.renderProductInfo: quantityInputSource found?', !!quantityInputSource);
        console.log('VariantSelects.renderProductInfo: quantityInputDestination found?', !!quantityInputDestination);
        // ★★★ デバッグログ追加ここまで ★★★

        if (quantityInputSource && quantityInputDestination) {
          const newMax = quantityInputSource.getAttribute('max'); // Get max value from fetched HTML
          const currentMax = quantityInputDestination.getAttribute('max'); // Get current max value on the page

          // ★★★ デバッグログ追加: 取得したmax値と現在のmax値 ★★★
          console.log(`VariantSelects.renderProductInfo: Fetched max value (newMax): ${newMax} (type: ${typeof newMax})`);
          console.log(`VariantSelects.renderProductInfo: Current max value (currentMax): ${currentMax} (type: ${typeof currentMax})`);
          // ★★★ デバッグログ追加ここまで ★★★

          if (newMax !== null && newMax !== undefined) { // Check if newMax exists (is not null or undefined)
            if (currentMax !== newMax) {
              quantityInputDestination.setAttribute('max', newMax);
              console.log(`VariantSelects.renderProductInfo: Set max attribute to ${newMax}`);
            } else {
              console.log(`VariantSelects.renderProductInfo: Max attribute already set to ${newMax}, no change needed.`);
            }
          } else { // If newMax doesn't exist in the fetched HTML
            if (currentMax !== null) { // Only remove if it currently exists
              quantityInputDestination.removeAttribute('max');
              console.log('VariantSelects.renderProductInfo: Removed max attribute as it was not present in fetched HTML.');
            } else {
              console.log('VariantSelects.renderProductInfo: No new max attribute found and no current max attribute exists, no change needed.');
            }
          }

          // Find the parent quantity-input component and update its button states
          const quantityInputComponent = quantityInputDestination.closest('quantity-input');
          if (quantityInputComponent && quantityInputComponent.updateButtonStates) {
            // Use setTimeout to ensure the attribute change is processed before updating states
            setTimeout(() => {
              console.log('QuantityInput: Calling updateButtonStates after renderProductInfo');
              quantityInputComponent.updateButtonStates();
              // Also, ensure the current value doesn't exceed the new max
              if (quantityInputComponent.onInputChange) {
                quantityInputComponent.onInputChange();
              }
            }, 0);
          } else {
            console.warn('QuantityInput: Could not find quantity-input component or updateButtonStates method after renderProductInfo.');
          }
        } else {
          console.warn('QuantityInput: Could not find source or destination quantity input during renderProductInfo.');
        }
        // --- ★★★ ここまで修正 ★★★ ---

        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      })
      .catch(error => {
        console.error('Error fetching product info:', error);
        // Optionally handle fetch errors here, e.g., show a generic error message
        this.toggleAddButton(true, 'エラーが発生しました');
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    var productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    var addButton = productForm.querySelector('[name="add"]');
    var addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    var button = document.getElementById(`product-form-${this.dataset.section}`);
    var addButton = button.querySelector('[name="add"]');
    var addButtonText = button.querySelector('[name="add"] > span');
    var price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    var fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

function getQueryParam(param) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
}

document.addEventListener('DOMContentLoaded', function () {
  var pageParam = getQueryParam('page');
  var pageQueryParamElement = document.getElementById('pageQueryParam');
  var collectionHeader = document.querySelector('#collection-header');

  if ((pageParam === null || pageParam == 1) && collectionHeader) {
    collectionHeader.style.display = 'block';
  }
});
